<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <div class="p-the-page-h12">
          <div class="p-the-page-h12__header">
            <CommonHeading>{{ title }}</CommonHeading>
            <a v-touch:tap :href="link" class="p-the-page-h12__header__link">
              <span class="p-the-page-h12__header__link__text">
                有効期限切れのポイントはこちら
              </span>
            </a>
          </div>
          <div v-if="expirationCnt == 0" class="p-the-page-h12__body">
            <p>有効期限間近のポイントはありません。</p>
          </div>
          <div v-if="expirationCnt != 0" class="p-the-page-h12__body">
            <ul class="p-the-page-h12__list">
              <li
                v-for="({ history_id, date, detail, point, label, status },
                key) in expirationData"
                :key="key"
                class="p-the-page-h12__list__item"
                @click="expiringDetails(history_id)"
              >
                <ExpirationItemPanel
                  :date="date"
                  :detail="detail"
                  :point="point"
                  :label="label"
                  :status="status"
                />
              </li>
            </ul>
          </div>
          <div class="p-the-page-h12__footer">
            <PageNavi
              v-if="pageNavi.maxPage > 1"
              :current-page="pageNavi.currentPage"
              :next-page-url="pageNavi.nextPageUrl"
              :prev-page-url="pageNavi.prevPageUrl"
              :max-page="pageNavi.maxPage"
              :base-url="pageNavi.baseUrl"
            />
          </div>
        </div>
      </div>
    </div>
    <FloatingGivePointButton />
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import ExpirationItemPanel from "@/general/components/pages/parts/ExpiringPoints/expirationItemPanel.vue";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { getExpirePointHistoryList } from "@/general/store/api";
import { getThanksOrGrantTypeLabel } from "@/common/assets/js/utils/types";
import {
  getQueryString,
  setQueryString
} from "@/common/assets/js/utils/queryParams";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import { UserInfo } from "@/general/store/models";
import AuthStorage from "@/general/utils/auth";

@Options({
  name: "ExpiringPoints",
  components: {
    ExpirationItemPanel
  }
})
export default class ExpiringPoints extends Vue {
  expirationData: any | undefined = [];
  //　初期表示の際、これを参照しているのでデータが有無かかわらず、メッセージが表示しているため、１をデフォルトで設定、
  // 実際の処理はサーバーから取得したデータで判断する。
  expirationCnt = 1;

  baseUrl = window.location.pathname;
  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };

  userInfo: UserInfo;
  setPageNav(count: number) {
    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    const { params } = this;
    params.page = parseInt(params.page + "", 10);

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = params.page;

    this.pageNavi.baseUrl =
      this.baseUrl + "?" + getQueryString({ ...params, page: undefined });
    this.pageNavi.nextPageUrl =
      this.baseUrl + "?" + getQueryString({ ...params, page: params.page + 1 });
    this.pageNavi.prevPageUrl =
      this.baseUrl + "?" + getQueryString({ ...params, page: params.page - 1 });
  }

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  async setPageData() {
    const breadcrumb = [
      {
        text: "",
        url: CONST_DATA.SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: "ポイント確認",
        url: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,

        pageType: "lower"
      },
      {
        text: this.title,
        url: "",
        pageType: "lower"
      }
    ];

    await commons.getBreadcrumb(breadcrumb);
  }

  params = {
    expiry_point_type: "expiring",
    page: 1,
    search: "",
    transaction_direction: "gaining"
  };

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queries = [
      { k: "expiry_point_type", v: this.params.expiry_point_type },
      { k: "page", v: 1 },
      { k: "search" }
    ];
    this.params = setQueryString(this.params, queries);

    await this.setPageData();
    this.userInfo = await this.getUserDetails();

    const response: any = await getExpirePointHistoryList(
      this.params.expiry_point_type,
      this.params.page,
      this.pageSize,
      this.params.search
    )
      .then((res) => {
        return res;
      })
      .catch(() => {
        window.location.href = CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
        return;
      });

    this.expirationData =
      response?.results?.map((res: any) => {
        const {
          pk,
          expiry_date,
          remaining_points,
          transaction_details,
          transaction_type,
          points,
          history_id
        } = res;

        if (transaction_type === 10) {
          // Use - Should never come to this
          return {
            history_id,
            date: expiry_date,
            detail: "",
            point: remaining_points,
            status: "利用"
          };
        } else if (
          transaction_type === 20 ||
          transaction_type === 30 ||
          transaction_type === 40 ||
          transaction_type === 80 ||
          transaction_type === 90 ||
          transaction_type === 100
        ) {
          // Grant Points - 20: NoLimit - 30:ThanksOnly - 40:GrantOnly
          const { grant_type } = transaction_details;
          const kindLabel = getThanksOrGrantTypeLabel(grant_type);
          return {
            history_id,
            date: expiry_date,
            detail: transaction_details?.title,
            point: remaining_points,
            status: "付与",
            label: kindLabel ? kindLabel : "",
            transaction_type
          };
        } else if (transaction_type === 50) {
          // User-to-User : Thanks Giving or Thanks Receiving

          const { from_user, to_user } = transaction_details;

          if (from_user?.id === this.userInfo?.user_id) {
            // Giving
            return {
              history_id,
              date: expiry_date,
              detail: to_user?.user_name,
              point: remaining_points,
              status: "贈与",
              transaction_type
            };
          } else if (to_user?.id === this.userInfo?.user_id) {
            // Receiving
            return {
              history_id,
              date: expiry_date,
              detail: from_user?.user_name,
              point: remaining_points,
              status: "受贈",
              transaction_type
            };
          } else {
            return {};
          }
        } else if (transaction_type === 60) {
          // Group Admin to User (distribution) - Should never come to this
          return {};
        } else if (transaction_type === 70) {
          const { grant_criteria } = transaction_details;

          const kindLabel =
            grant_criteria && grant_criteria.kind
              ? getThanksOrGrantTypeLabel(grant_criteria.kind)
              : null;
          const detail = transaction_details?.title;
          const status =
            grant_criteria && grant_criteria.id
              ? "付与"
              : this.userInfo?.user_id === transaction_details.from_user.id
              ? this.thanksPointName + "贈与"
              : this.thanksPointName + "受贈";

          return {
            history_id,
            date: expiry_date,
            detail,
            point: points,
            status,
            label: kindLabel
          };
        }
      }) || [];

    this.setPageNav(response.count as number);
    this.expirationCnt = response.count as number;
  }

  async getUserDetails(): Promise<UserInfo> {
    return auth.user;
  }

  get title() {
    return "ポイント有効期限一覧";
  }

  get link() {
    return `${CONST_DATA.SITE_MAP.EXPIRED_POINTS}`;
  }

  expiringDetails(id: number) {
    window.location.href = `${CONST_DATA.SITE_MAP.EXPIRING_POINT_DETAILS}?id=${id}`;
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-h12 {
  @include pc {
    max-width: rem(1110);
    margin: 0 auto;
    padding: rem(32) 0 rem(56);
  }
  @include sp {
    padding: rem(32) 0 0;
  }

  &__header {
    @include pc {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    ::v-deep(.c-common-heading1) {
      @include sp {
        font-size: rem(20);
      }
    }
    &__link {
      @include sp {
        margin-top: rem(24);
      }
      color: $common-primary;
      display: block;

      &.tap {
        color: $common-primary;
        text-decoration: underline;
      }

      &__text {
        font-weight: bold;
        font-size: rem(14);
      }
    }
  }

  &__body {
    @include pc {
      margin-top: rem(16);
      padding: rem(16) rem(8);
    }
    @include sp {
      padding: rem(24) 0 rem(48);
    }
    background-color: $common-white;
    border-radius: rem(4);
  }

  &__list {
    &__item {
      cursor: pointer;
      @include pc {
        border-bottom: px(1) solid $common-gray300;
      }
      @include sp {
        border: px(1) solid $common-gray300;
        border-radius: rem(4);
        padding: 0 rem(12);
        margin-bottom: rem(8);
      }
    }
  }

  &__footer {
    margin: rem(24) 0 0;
  }
}
</style>
